import { CSSObjectWithLabel } from 'react-select'
import vectorIcon from '../../images/vector.svg';

export const customSelectStylesForJobForm = {
  control: (baseStyles: CSSObjectWithLabel) => ({
    ...baseStyles,
    border: '1px solid #E8E8E8',
    boxShadow: 'none',
    borderRadius: '10px',
    padding: '2px 3px',
  }),
  placeholder: (baseStyles: CSSObjectWithLabel) => ({
    ...baseStyles,
    color: '#333',
  }),
  indicatorSeparator: (baseStyles: CSSObjectWithLabel) => ({
    ...baseStyles,
    display: 'none',
  }),
  dropdownIndicator: (baseStyles: CSSObjectWithLabel) => ({
    ...baseStyles,
    color: 'transparent',
    backgroundImage: `url(${vectorIcon})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '8px auto',
    backgroundPosition: 'right 12px center',
    ':hover': {
      color: 'transparent'
    },
  })
}

export const customSelectStylesForJobIndex = {
  control: (baseStyles: CSSObjectWithLabel) => ({
    ...baseStyles,
    backgroundColor: 'rgb(250, 250, 251)',
    border: '1px solid #E8E8E8',
    boxShadow: 'none',
    borderRadius: '10px',
    padding: '1px 3px',
  }),
  menu: (baseStyles: CSSObjectWithLabel) => ({
    ...baseStyles,
    backgroundColor: 'rgb(250, 250, 251)',
    color: '#0C4E88',
    fontSize: '12px'
  }),
  singleValue: (baseStyles: CSSObjectWithLabel) => ({
    ...baseStyles,
    color: '#0C4E88',
    fontSize: '12px'
  }),
  placeholder: (baseStyles: CSSObjectWithLabel) => ({
    ...baseStyles,
    color: '#0C4E88',
    fontSize: '12px'
  }),
  indicatorSeparator: (baseStyles: CSSObjectWithLabel) => ({
    ...baseStyles,
    display: 'none',
  }),
  dropdownIndicator: (baseStyles: CSSObjectWithLabel) => ({
    ...baseStyles,
    color: 'transparent',
    backgroundImage: `url(${vectorIcon})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '8px auto',
    backgroundPosition: 'right 12px center',
    ':hover': {
      color: 'transparent'
    },
  }),
  input: (baseStyles: CSSObjectWithLabel) => ({
    ...baseStyles,
    color: '#0C4E88',
    fontSize: '12px'
  })
}
